import { CreateTypeData, typeListResponseSchema } from '@/features/types/services/schemas.ts';
import { ApiClient } from '@/common/api/ApiClient.ts';
import { createEntityResponseSchema } from '@/common/api/schemas.ts';
import { SieveParams } from '@/common/api/sieveAdapter.ts';

export const TypeService = {
  list: async (producerId: string) => {
    return await ApiClient.get('/types', typeListResponseSchema, {
      filters: `producerId==${producerId}`,
      pageSize: 2147483647,
    } satisfies SieveParams);
  },
  create: async (data: CreateTypeData) => {
    return await ApiClient.post('/types', data, createEntityResponseSchema);
  },
};
